module.exports = __webpack_public_path__ + "static/media/girl-7.9eef213f.svg";